export const PARTNER_LEVELS = {
  "P-00": { label: "Partenaire 00", color: "bg-gray-100 text-gray-800" },
  "P-12": { label: "Partenaire 12", color: "bg-blue-100 text-blue-800" },
  "P-24": { label: "Partenaire 24", color: "bg-green-100 text-green-800" },
  "P-36": { label: "Partenaire 36", color: "bg-purple-100 text-purple-800" },
  "E-50": { label: "Étoile 50", color: "bg-yellow-100 text-yellow-800" },
};

export const PRODUCT_TYPES = {
  texte_simple: { label: "Documents textes", icon: "📚", maxPC: 1 },
  texte_sonorise: { label: "Fichier audio", icon: "🎧", maxPC: 1 },
  texte_chante: { label: "Fichier video", icon: "🎬", maxPC: 1 },
};

export const PRODUCT_STATUS = {
  pending: { label: "En attente", color: "bg-yellow-100 text-yellow-800" },
  validated: { label: "Validé", color: "bg-green-100 text-green-800" },
  rejected: { label: "Rejeté", color: "bg-red-100 text-red-800" },
};

export const BONUS_TYPES = {
  // Bonus-Édition
  bonus_auteur: { label: "Bonus Auteur (BA)", rate: "50%", category: "Édition" },
  bonus_auteur_1: { label: "Bonus Auteur 1 (BA1)", rate: "4%", category: "Édition" },
  bonus_auteur_2: { label: "Bonus Auteur 2 (BA2)", rate: "3%", category: "Édition" },
  bonus_auteur_3: { label: "Bonus Auteur 3 (BA3)", rate: "2%", category: "Édition" },
  etoile_bonus_auteur: { label: "Étoile Bonus Auteur (E-BA)", rate: "2%", category: "Édition" },
  bonus_demarchage_acheteur: { label: "Bonus Démarchage (BDA)", rate: "10%", category: "Édition" },
  etoile_bonus_demarchage_acheteur: { label: "Étoile Bonus Démarchage (E-BDA)", rate: "2%", category: "Édition" },
  bonus_filleul_acheteur_1: { label: "Bonus Filleul 1 (BFA1)", rate: "5%", category: "Édition" },
  bonus_filleul_acheteur_2: { label: "Bonus Filleul 2 (BFA2)", rate: "3%", category: "Édition" },
  bonus_filleul_acheteur_3: { label: "Bonus Filleul 3 (BFA3)", rate: "2%", category: "Édition" },
  etoile_bonus_filleul_acheteur: { label: "Étoile Bonus Filleul (E-BFA)", rate: "2%", category: "Édition" },
  accompagnement_fondateur_edition: { label: "Accompagnement Fondateur", rate: "3%", category: "Édition" },
  // Bonus-Parrainage
  bonus_parrainage_1: { label: "Bonus Parrainage 1 (BP1)", rate: "50%", category: "Parrainage" },
  bonus_parrainage_2: { label: "Bonus Parrainage 2 (BP2)", rate: "10%", category: "Parrainage" },
  bonus_parrainage_3: { label: "Bonus Parrainage 3 (BP3)", rate: "5%", category: "Parrainage" },
  etoile_bonus_parrainage: { label: "Étoile Bonus Parrainage (E-BP)", rate: "5%", category: "Parrainage" },
  accompagnement_fondateur_parrainage: { label: "Accompagnement Fondateur", rate: "5%", category: "Parrainage" },
  // Bonus-Équipe
  bonus_equipe_p12: { label: "Bonus Équipe P-12", rate: "12%", category: "Équipe" },
  bonus_equipe_p24: { label: "Bonus Équipe P-24", rate: "14%", category: "Équipe" },
  bonus_equipe_p36: { label: "Bonus Équipe P-36", rate: "17%", category: "Équipe" },
  bonus_equipe_e50: { label: "Bonus Équipe E-50", rate: "22%", category: "Équipe" },
  accompagnement_fondateur_equipe: { label: "Accompagnement Fondateur", rate: "5%", category: "Équipe" },
  // Bonus-Multiplication
  bonus_multiplication_e3: { label: "Bonus Multiplication E3", rate: "5%", category: "Multiplication" },
  bonus_multiplication_e2: { label: "Bonus Multiplication E2", rate: "3%", category: "Multiplication" },
  bonus_multiplication_e1: { label: "Bonus Multiplication E1", rate: "2%", category: "Multiplication" },
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("fr-FR", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const formatCurrency = (amount) => {
  return `${amount.toFixed(2)} MC`;
};
